// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomAirflow } from './RoomAirflow';
import {
    RoomAirflowFromJSON,
    RoomAirflowFromJSONTyped,
    RoomAirflowToJSON,
    RoomAirflowToJSONTyped,
} from './RoomAirflow';
import type { RoomContact } from './RoomContact';
import {
    RoomContactFromJSON,
    RoomContactFromJSONTyped,
    RoomContactToJSON,
    RoomContactToJSONTyped,
} from './RoomContact';
import type { RoomMonitoring } from './RoomMonitoring';
import {
    RoomMonitoringFromJSON,
    RoomMonitoringFromJSONTyped,
    RoomMonitoringToJSON,
    RoomMonitoringToJSONTyped,
} from './RoomMonitoring';

/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * Room ID
     */
    roomId: string;
    /**
     * 
     */
    contact: RoomContact;
    /**
     * Room number
     */
    number: string;
    /**
     * Room name
     */
    name?: string;
    /**
     * 
     */
    airflow: RoomAirflow;
    /**
     * Monitoring functions for this room
     */
    monitoring: Array<RoomMonitoring>;
    /**
     * Hide the room from end-user views (still listed in admin)
     */
    hidden?: boolean;
}

/**
 * Check if a given object implements the Room interface.
 */
export function instanceOfRoom(value: object): value is Room {
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('contact' in value) || value['contact'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('airflow' in value) || value['airflow'] === undefined) return false;
    if (!('monitoring' in value) || value['monitoring'] === undefined) return false;
    return true;
}

export function RoomFromJSON(json: any): Room {
    return RoomFromJSONTyped(json, false);
}

export function RoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): Room {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'],
        'contact': RoomContactFromJSON(json['contact']),
        'number': json['number'],
        'name': json['name'] == null ? undefined : json['name'],
        'airflow': RoomAirflowFromJSON(json['airflow']),
        'monitoring': ((json['monitoring'] as Array<any>).map(RoomMonitoringFromJSON)),
        'hidden': json['hidden'] == null ? undefined : json['hidden'],
    };
}

export function RoomToJSON(json: any): Room {
    return RoomToJSONTyped(json, false);
}

export function RoomToJSONTyped(value?: Room | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'contact': RoomContactToJSON(value['contact']),
        'number': value['number'],
        'name': value['name'],
        'airflow': RoomAirflowToJSON(value['airflow']),
        'monitoring': ((value['monitoring'] as Array<any>).map(RoomMonitoringToJSON)),
        'hidden': value['hidden'],
    };
}

